import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { makeHeaderRow } from '../../utils/goal_statics';
import * as staticsApi from '../../lib/api/statics';
import GoalStaticsTotalTable from '../../components/goal_statics/GoalStaticsTotalTable';
import { getDeptList } from '../../lib/api/establish';

const GoalStaticsTotalContainer = ({
  selectedYear,
  strMonth,
  endMonth,
  tableRef,
  searchDate,
  selectedGbn,
  selectedLabel,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 초기값을 빈 배열로 설정 (안전성)
  const [headerRows, setHeaderRows] = useState(null);
  const [deptList, setDeptList] = useState([]);

  // useCallback으로 감싸서 불필요한 재생성 방지
  const onLoadData = useCallback(async () => {
    setLoading(true); // 로딩 시작
    try {
      // 1. 부서 리스트와 데이터 호출 병렬 처리 (속도 향상)
      const [deptRes, res] = await Promise.all([
        getDeptList(),
        staticsApi.getTotalExpectStatics(selectedYear, strMonth, endMonth)
      ]);

      const depts = deptRes.data?.list || [];
      setDeptList(depts);

      if (res.data?.list) {
        // 서버에서 받은 리스트(Array)를 그대로 저장
        setData(res.data.list);
      } else {
        setData([]);
      }

      const loadedHeaders = makeHeaderRow(strMonth, endMonth);
      setHeaderRows(loadedHeaders);
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setLoading(false); // 로딩 종료
    }
  }, [selectedYear, strMonth, endMonth, enqueueSnackbar]);

  useEffect(() => {
    // searchDate 조건이 필요하다면 주석 해제하여 사용
    onLoadData();
  }, [onLoadData]);

  return (
    <GoalStaticsTotalTable
      selectedLabel={selectedLabel}
      data={data} // 이제 data는 [{...}, {...}] 형태의 배열임
      loading={loading}
      headerRows={headerRows}
      deptList={deptList}
      tableRef={tableRef}
    />
  );
};

export default GoalStaticsTotalContainer;
